import { render } from "./Tooltip.vue?vue&type=template&id=f161e1f4"
import script from "./Tooltip.vue?vue&type=script&lang=ts"
export * from "./Tooltip.vue?vue&type=script&lang=ts"
script.render = render

export default script